import footerBg from "../assets/images/footerBg.jpg";

export default function Landing() {
  return (
    <div
      className="d-flex"
      style={{
        background: `linear-gradient(0deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.40) 100%), url(${footerBg}) lightgray 50% / cover no-repeat`,
        height: "100vh",
      }}
    >
      <a
        href="https://www.young-gallery.com"
        className="text-decoration-none text-dark bg-light m-auto py-4 px-5 rounded fs-5 shadow fw-bold hover-btn"
      >
        انتقال به یانگ گالری
      </a>
    </div>
  );
}
